<template>
  <div id="notify" class="vs-con-loading__container">
    <order-invoice v-if="order" :config="invoiceConfig" :order="order"></order-invoice>
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Invoice list</span>
        </li>
      </ul>
    </div>
    <h3 class="my-4 py-4">Invoice list</h3>
    <div v-for="(invoice, index) in invoiceList.items" :key="index">
      <vx-card class="my-3">
        <div class="flex w-full">
          <div class="flex align-left w-9/12 md:w-10/12">
            <div
              class="mr-6 text-lg font-bold"
            >#{{invoice.order.order_code}}: {{invoice.order.customer_name}} - {{invoice.order.customer_phone}}</div>
          </div>
          <div class="text-xs w-3/12 md:w-2/12 text-center">{{dateAgo(invoice.created_at)}}</div>
        </div>
        <div class="sm:flex justify-between">
          <div
            v-if="invoice.order.order_items[0] !== undefined"
            class="w-full mt-4 text-sm md:w-10/12 sm:w-9/12"
          >{{invoice.order.order_items[0].item_name}} {{(invoice.order.order_items.length > 1) ? '& ' + (invoice.order.order_items.length - 1) + ' other item(s)': ''}}</div>
          <div v-else class="w-full mt-4 text-sm md:w-10/12 sm:w-9/12"></div>
          <div class="w-full md:w-2/12 sm:w-3/12 sm:pt-0 pt-6 flex justify-center">
            <vs-button
              class="text-sm w-full sm:w-auto"
              color="primary"
              @click="viewInvoice(invoice.order)"
              style="padding: 0.75rem 1rem"
            >View invoice</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <div
      v-if="invoiceList && invoiceList._meta && parseInt(invoiceList._meta.pageCount) > 1"
      class="mt-base"
    >
      <custom-pagination
        class="custom-pagination"
        :totalPages="parseInt(invoiceList._meta.pageCount)"
        :currentPage="currentPage"
        @pageChanged="changePage"
        :key="page_key"
      ></custom-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      invoiceList: [],
      page_key: 0,
      invoiceConfig: {
        isOpen: false
      },
      order: null
    };
  },
  watch: {
    invoiceConfig: {
      immediate: true,
      deep: true,
      handler() {
        if(this.invoiceConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  },
  created() {
    const obj = {
      page: 1,
      "per-page": 10
    };
    this.$store.dispatch("orderInvoice/ORDER_INVOICE_LIST", obj).then(() => {
      this.invoiceList = this.$store.getters["orderInvoice/orderInvoiceList"];
    });
  },
  methods: {
    dateAgo(created_at) {
      let create = new Date(created_at);
      let currentDate = new Date();
      let type = "";
      let Difference_In_Time = currentDate.getTime() - create.getTime();
      let Difference_In_Day = 0;
      let Difference_In_Days = Difference_In_Time / (1000 * 3600);
      if (Difference_In_Days < 24) {
        Difference_In_Day = Difference_In_Days;
        type = "h ago";
      }
      if (Difference_In_Days >= 24) {
        Difference_In_Day = Difference_In_Days / 24;
        type = " days ago";
      }
      if (Difference_In_Days >= 720) {
        Difference_In_Day = Difference_In_Days / 720;
        type = " months ago";
      }
      if (Difference_In_Days >= 720 * 12) {
        Difference_In_Day = Difference_In_Days / (720 * 12);
        type = " years ago";
      }
      return Math.round(Difference_In_Day) + type;
    },
    viewInvoice(order) {
      this.order = order;
      this.invoiceConfig.isOpen = true;
    },
    changePage(currentPage) {
      const obj = {
        page: currentPage,
        "per-page": this.itemsPerPage
      };
      this.$store.dispatch("orderInvoice/ORDER_INVOICE_LIST", obj).then(() => {
        this.currentPage = currentPage;
        this.page_key++;
        this.invoiceList = this.$store.getters["orderInvoice/orderInvoiceList"];
      });
    }
  }
};
</script>